import React, { useEffect, useState } from "react";
import {wpurl} from '../gsurl'
import { X } from 'lucide-react';
import '../Blog.css';

// Styles
const Container = ({ className, children }) => (
  <div className={`min-h-screen bg-gray-50 ${className}`}>{children}</div>
);

const MenuButton = ({ onClick, isOpen }) => (
  <button 
    className=" top-4 left-4 z-50 p-2 bg-white rounded-md shadow-lg md:hidden"
    onClick={onClick}
  >
    {/* {isOpen ? <X size={24} /> : <Menu size={24} />} */}
    {isOpen ? <X size={24} /> : <div>Blog Posts</div>}
  </button>
);

const LayoutWrapper = ({ children }) => (
  <div className="flex flex-col md:flex-row">{children}</div>
);

const Sidebar = ({ isOpen, children }) => (
  <div className={`
    fixed md:relative
    inset-0 z-40
    w-64 md:w-1/3 lg:w-1/4
    bg-white
    transform transition-transform duration-300 ease-in-out
    ${isOpen ? 'translate-x-0' : '-translate-x-full'}
    md:translate-x-0
    overflow-y-auto
    border-r border-gray-200
    pt-16 md:pt-4
  `}>
    {children}
  </div>
);

const SidebarContent = ({ children }) => (
  <div className="px-4">{children}</div>
);

const PostList = ({ children }) => (
  <div className="space-y-4">{children}</div>
);

const PostItem = ({ isSelected, onClick, children }) => (
  <div
    className={`
      p-3 rounded-lg cursor-pointer
      ${isSelected ? 'bg-blue-50 border border-blue-500' : 'hover:bg-gray-50'}
    `}
    onClick={onClick}
  >
    {children}
  </div>
);

const MainContent = ({ children }) => (
  <div className="flex-1 p-4 md:p-8">{children}</div>
);

const Article = ({ children }) => (
  <article className="max-w-3xl mx-auto">{children}</article>
);

const Overlay = ({ onClick }) => (
  <div 
    className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
    onClick={onClick}
  />
);

// Main Component
const Blog = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [posts, setPosts] = useState(null);
  const [selectedPost, setSelectedPost] = useState();


      useEffect(() => {


        const fetchWordPressPost = async () => {
            try {
              const response = await fetch(wpurl+'/posts?_embed&categories=273'); 
              const posts = await response.json();
              setSelectedPost(posts[0]);
              setPosts(posts);
              // console.log(posts[0])
            } catch (error) {
              console.error('Error fetching latest post:', error);
            }
          };
      
          fetchWordPressPost()
      }, []);

      if (!selectedPost) {
        return <div>Loading...</div>;
      }  


  const handlePostSelect = (post) => {
    setSelectedPost(post);
    setIsMobileMenuOpen(false);
  };

  return (
    <Container>
      <MenuButton 
        isOpen={isMobileMenuOpen}
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      />

      <LayoutWrapper>
        <Sidebar isOpen={isMobileMenuOpen}>
          <SidebarContent>
            <h2 className="text-xl font-bold mb-4">Blog Posts</h2>
            <PostList>
              {posts.map(post => (
                
                <PostItem
                  key={post.slug}
                  isSelected={selectedPost.slug === post.slug}
                  onClick={() => handlePostSelect(post)}
                >
                  <div dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
                  <p className="article-date">{post.date.split('T')[0]}</p>
                </PostItem>
              ))}
            </PostList>
          </SidebarContent>
        </Sidebar>

        <MainContent>
          <Article>
            <div className="text-3xl font-bold mb-4 text-center" dangerouslySetInnerHTML={{__html: selectedPost.title.rendered}} />
            <div dangerouslySetInnerHTML={{ __html: selectedPost.content.rendered }} />
          </Article>
        </MainContent>
      </LayoutWrapper>

      {isMobileMenuOpen && (
        <Overlay onClick={() => setIsMobileMenuOpen(false)} />
      )}
    </Container>
  );
};


export default Blog;


